import { PlpMarketingTileItem } from 'src/data/Contentful/ContentfulListPlpMarketingTiles';
import { PlpMarketingTile } from '../components/PlpMarketingTile/PlpMarketingTile';

export const getMarketingTile = (
  indexesMarketingTiles: number[],
  /** Page number (zero indexed) */
  page: number,
  index: number,
  marketingTiles: PlpMarketingTileItem['tileContent'][],
) => {
  const tileIndex = indexesMarketingTiles.indexOf(index);
  // Limit based on the page and index
  if (page <= 3 && tileIndex >= 0 && marketingTiles.length > page * indexesMarketingTiles.length + tileIndex) {
    const tileData = marketingTiles[page * indexesMarketingTiles.length + tileIndex];

    return (
      <li data-testid="plp-marketing-tile">
        <PlpMarketingTile
          {...tileData}
          variant="plp"
          plpMarketingTileClickEvent={{
            event: 'marketing_tile_click',
            index: tileIndex,
            index_max: marketingTiles.length - 1,
          }}
        />
      </li>
    );
  }

  return null;
};
